<table
  *ngIf="portfolioHistoricWeightedRows?.rowData?.length > 0"
  class="table table--base-size table--secondary print-hidden"
  edsSpacing="sm"
>
  <thead class="table__thead">
    <tr class="table__tr">
      <th class="table__th">
        <strong>{{
          "products.portfolio-historic-as-of-date" | translate
        }}</strong>
      </th>
      <th class="table__th bold text-align-right">
        <strong
          >{{ portfolioHistoricWeightedRows?.averageLifeHeading }}
        </strong>
        <eds-footnote
          [placement]="
            portfolioHistoricWeightedRows?.averageLifeCaveatPlacement
          "
        ></eds-footnote>
        <button
          class="print-hidden"
          edsTooltip
          [tooltipContent]="portfolioHistoricWeightedRows?.averageLifeTooltip"
          [tooltipAriaLabel]="'products.benchmark' | translate"
          [tooltipButton]="true"
        >
          <eds-icon type="info" size="small"></eds-icon>
        </button>
      </th>
      <th class="table__th bold text-align-right">
        <strong>{{
          portfolioHistoricWeightedRows?.averageMaturityHeading
        }}</strong>
        <eds-footnote
          [placement]="
            portfolioHistoricWeightedRows?.averageMaturityCaveatPlacement
          "
        ></eds-footnote>
        <button
          class="print-hidden"
          edsTooltip
          [tooltipContent]="
            portfolioHistoricWeightedRows?.averageMaturityTooltip
          "
          [tooltipAriaLabel]="'products.potfolio-hitsotric-weight' | translate"
          [tooltipButton]="true"
        >
          <eds-icon type="info" size="small"></eds-icon>
        </button>
      </th>
    </tr>
  </thead>
  <tbody class="table__body">
    <tr *ngFor="let row of portfolioHistoricWeightedRows?.rowData">
      <td class="table__td">
        {{ row.asOfDate }}
      </td>
      <td class="table__td text-align-right">
        <strong class="bold">{{ row.averageLife }}</strong>
      </td>
      <td class="table__td text-align-right">
        <strong class="bold">{{ row.averageMaturity }}</strong>
      </td>
    </tr>
  </tbody>
</table>
